export var mapHeight = '_3r_y0';
export var listButtonPosition = '_2x2iA';